import statusCodes from "./status.codes";

/**
 * Converts a stringified array of status codes (e.g. "[100, 102, 101]") to a comma-separated string of status messages.
 * Handles extra spaces, periods, and invalid entries gracefully.
 * @param {string} arrayString
 * @returns {string}
 */
export function getStatusMessagesFromArrayString(arrayString) {
  if (!arrayString || typeof arrayString !== "string") return "";
  
  // Handle empty arrays explicitly
  const trimmed = arrayString.trim();
  if (trimmed === "[]" || trimmed === "") return "";
  
  // Remove brackets and split by comma
  const codes = arrayString
    .replace(/\[|\]/g, "")
    .split(",")
    .map(s => s.replace(/\./g, "").trim())
    .filter(s => s !== "") // Filter out empty strings
    .map(Number)
    .filter(n => !isNaN(n));
    
  if (codes.length === 0) return "";
  
  const messages = codes.map(code => statusCodes[code] || code);
  return messages.join(", ");
}
